import React from "react";

export const EmployeeSalary = React.lazy(() => import("./EmployeeSalary"));
export const PayRollItems = React.lazy(() => import("./PayRollItems"));
export const SalaryProcess = React.lazy(() => import("./SalaryProcess"));
export const SalaryReport = React.lazy(() => import("./SalaryReport"));
export const PLReport = React.lazy(() => import("./PLReport"));
